/**
 * Each category has an image defined as the key in Cloudinary. The name you can find in
 * the repository where images are stored.
 *
 * https://github.com/photolane/parabo-product-images/tree/master/categories
 */
const PRODUCT_CATEGORIES = [
  {
    id: 'print-sets',
    url: '/print-sets',
    image: 'categories/printsets',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'square-prints',
          'classic-prints',
          'glossy-prints',
          // 'tiny-square-prints',
          "photobooth-magnets",
          // 'photo-strips',
        ],
        productsFirst: true,
      },
    ],
  },
  {
    // Photo Cards hub (pages/cards.js), name and SEO copy from content/categories/cards.md.
    id: 'cards',
    url: '/cards',
    data: [
      {
        subCategories: ['custom-photo-holiday-cards', 'custom-photo-greeting-cards'],
        products: [],
      },
    ],
  },
  {
    id: 'wall-art',
    url: '/wall-art',
    image: 'categories/wallart',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'acrylic-prints',
          'wrapped-canvas-prints',
          'metal-wall-prints',
          'engineer-prints',
          'square-engineer-prints',
          'framed-prints',
          'artprint',
          'news-print',
        ],
      },
    ],
  },
  {
    id: 'desk',
    url: '/desk',
    image: 'categories/desk',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'metal-desk-prints',
          "acrylic-magnets",
          'wood-block',
        ],
      },
    ],
  },
  {
    id: 'photo-books',
    url: '/photo-books',
    image: 'categories/books',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'softcover-books',
          'hardcover-book',
          'premium-hardcover-books'
        ],
      },
    ],
  },
  {
    id: 'calendars',
    url: '/calendars',
    image: 'categories/calendars',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'engineer-print-calendar',
          'wall-calendar',
          'wall-calendar-large',
          // 'desktop-calendar',
          // 'desktop-calendar-flip',
        ],
      },
    ],
  },
  {
    id: 'display',
    url: '/display',
    image: 'categories/display',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          "acrylic-magnets",
          "photobooth-magnets",
          'wooden-rails',
          'wood-block',
          // 'good-hangups',
          'photo-ropes',
          'square-envelopes',
        ],
      },
    ],
  },
  {
    id: 'gifts',
    url: '/gifts',
    image: 'categories/gifts',
    banner: true,
    data: [
      {
        subCategories: ['gifts-under-20', 'gifts-under-50'],
        products: ['giftcard'],
      },
    ],
  },
  {
    id: 'gifts-under-20',
    url: '/gifts-under-20',
    name: 'Shop Gifts Under $20',
    seoTitle: 'Photo Gifts Under $20',
    image: 'categories/gifts20',
    shortDescription:
      'Turn your best moments and memories into presents they’ll cherish, and stuff their stockings with personalized gifts that’ll make them smile.',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'square-prints',
          'metal-desk-prints',
          'classic-prints',
          'glossy-prints',
          'softcover-books',
          'wood-block',
        ],
      },
    ],
  },
  {
    id: 'gifts-under-50',
    url: '/gifts-under-50',
    name: 'Shop Gifts Under $50',
    seoTitle: 'Photo Gifts Under $50',
    image: 'categories/gifts50',
    shortDescription:
      'You’ll be the best gift giver around. Turn your most special photos into beautiful keepsakes.',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          'engineer-prints',
          'artprint',
          'metal-wall-prints',
          'hardcover-book',
          // 'framed-art-prints',
          'news-print',
          // 'desktop-calendar',
          // 'desktop-calendar-flip',
          'wall-calendar',
          'wall-calendar-large',
          'wooden-rails',
        ],
      },
    ],
  },
  {
    id: 'photo-gift-stocking-stuffers',
    url: '/photo-gift-stocking-stuffers',
    name: 'Stocking Stuffers',
    seoTitle: 'Photo Stocking Stuffers',
    image: 'categories/stocking',
    shortDescription:
      'Fill their stockings with joyful reminders of your best moments. Mini photo books, Square Prints and wood blocks make little gifts kids love.',
    banner: true,
    data: [
      {
        subCategories: [],
        products: [
          // 'tiny-square-prints',
          'softcover-books',
          // 'desktop-calendar-flip',
          'square-prints',
          'wood-block',
          'photo-ropes',
          'giftcard',
        ],
      },
    ],
  },
  {
    id: 'custom-photo-holiday-cards',
    cardPresentation: 'product-group',
    url: '/custom-photo-holiday-cards',
    customPage: true,
    image: 'categories/cards',
    data: [
      {
        subCategories: [],
        products: ['photo-card', 'photo-card-foil'],
      },
    ],
  },
  {
    id: 'custom-photo-greeting-cards',
    cardPresentation: 'product-group',
    url: '/custom-photo-greeting-cards',
    customPage: true,
    image: 'categories/greeting-card',
    data: [
      {
        subCategories: [],
        products: ['photo-greeting-card', 'photo-greeting-card-foil'],
      },
    ],
  },
  {
    id: 'magnets',
    url: '/magnets',
    image: 'categories/magnets',
    banner: true,
    data: [
      {
        subCategories: [],
        products: ['acrylic-magnets', 'photobooth-magnets'],
      },
    ],
  },
];

export default PRODUCT_CATEGORIES;
